import { apiHost, apiKey } from "@/constants";
import {
  WorktableCompleteResponse,
  WorktableInfo,
  WorktableOutcome,
  WorktableScanResponse,
  WorktableStats,
} from "./types";

const headers = {
  "Content-Type": "application/json",
  "x-api-key": apiKey,
};

export async function fetchWorktables(): Promise<WorktableInfo[]> {
  const response = await fetch(`${apiHost}/worktable-scan/worktables`, { headers });
  if (!response.ok) {
    throw new Error("WORKTABLES_FETCH_FAILED");
  }
  return response.json();
}

export async function fetchWorktableStats(
  worktableId: number
): Promise<{ worktable: WorktableInfo; stats: WorktableStats }> {
  const response = await fetch(`${apiHost}/worktable-scan/${worktableId}/stats`, { headers });
  if (!response.ok) {
    throw new Error("WORKTABLE_STATS_FETCH_FAILED");
  }
  return response.json();
}

export async function scanWorktable(worktableId: number, dataString: string): Promise<WorktableScanResponse> {
  const response = await fetch(`${apiHost}/worktable-scan/${worktableId}/scan`, {
    method: "POST",
    headers,
    body: JSON.stringify({ dataString }),
  });
  const data = await response.json();
  if (!response.ok) {
    throw new Error(data?.message || "WORKTABLE_SCAN_FAILED");
  }
  return data;
}

export async function completeWorktableScan(
  worktableId: number,
  dataString: string,
  outcome: WorktableOutcome
): Promise<WorktableCompleteResponse> {
  const response = await fetch(`${apiHost}/worktable-scan/${worktableId}/complete`, {
    method: "POST",
    headers,
    body: JSON.stringify({ dataString, outcome }),
  });
  const data = await response.json();
  if (!response.ok) {
    throw new Error(data?.message || "WORKTABLE_COMPLETE_FAILED");
  }
  return data;
}
